import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Card, Table, Badge, Form } from 'react-bootstrap';
import api from '../lib/api';
import PageHeader from '../components/PageHeader.jsx';

const OUTCOME_COLOR = { success: 'success', failure: 'danger', denied: 'warning' };

export default function AuditPage() {
  const [filterAction, setFilterAction] = useState('');

  const audit = useQuery({
    queryKey: ['audit', filterAction],
    queryFn: () => api.get('/audit', { params: { limit: 200, action: filterAction || undefined } }).then(r => r.data.items)
  });

  return (
    <>
      <PageHeader title="Audit-Log" subtitle="Append-only — alle zustandsändernden Aktionen" />
      <Form.Group className="mb-3" style={{ maxWidth: 320 }}>
        <Form.Control placeholder="Filter: action (z.B. license.revoke)"
          value={filterAction} onChange={(e) => setFilterAction(e.target.value)} />
      </Form.Group>
      <Card className="card-flat">
        <Card.Body className="p-0">
          <Table hover size="sm" className="mb-0 align-middle">
            <thead className="table-light">
              <tr><th>Zeit</th><th>Action</th><th>Resource</th><th>Outcome</th><th>Details</th></tr>
            </thead>
            <tbody>
              {(audit.data || []).map(row => (
                <tr key={row.id}>
                  <td className="text-muted small text-nowrap">{new Date(row.created_at).toLocaleString('de-DE')}</td>
                  <td><code className="small">{row.action}</code></td>
                  <td className="small">
                    {row.resource_type && <>{row.resource_type}{row.resource_id ? ` · ${row.resource_id.slice(0, 8)}…` : ''}</>}
                  </td>
                  <td><Badge bg="" className={`badge-soft-${OUTCOME_COLOR[row.outcome] || 'secondary'}`}>{row.outcome}</Badge></td>
                  <td><pre className="small mb-0 text-muted" style={{ maxWidth: 600, whiteSpace: 'pre-wrap' }}>{JSON.stringify(row.details)}</pre></td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </>
  );
}
